import { apiGet } from '../client';
import { DashboardResponseSchema, type Dashboard } from '../schemas';

export async function getDashboard(): Promise<Dashboard> {
  return (await apiGet('/v1/business/dashboard', DashboardResponseSchema)).data;
}
